<template>
    <div class="recruiting-search col-10">
        <div class="flex justify-between items-center mt-1 mb-4">
            <h1 class="my-0">Company Search</h1>
        </div>

        <div class="flex justify-end items-start mb-2">
            <div>
                <vue-bootstrap-typeahead
                    class="mb-1"
                    v-model="query"
                    :data="ids"
                    ref="search"
                    :serializer="item => `${item.ClientName}`"
                    @hit="selected($event)"
                    placeholder="Search for a Company"
                    />
                
                <div class="text-grey-dark text-center text-xs">Use the search box above to search for a company by name.</div>
            </div>
            <button v-on:click="clearSearch" class="btn btn-light btn-lg mt-1 ml-2" :disabled="selectedId == null">Clear</button>
        </div> 

        <div class="relative flex flex-col border border-gray-200card-default">
            <div class="header-row border-b border-gray-200">Selected Company

                <span style="float:right;">
                    <button v-on:click="newSTD" class="btn btn-sm btn-primary" :disabled="selectedId == null || loading">
                        <span v-show="loading">
                            <i class="fa fa-spinner fa-pulse fa-fw"></i>
                        </span>
                        New Details
                    </button>
                </span>

            </div>

            <div class="card-body pt-0">

                <div class="flex">
                    <div class="text-grey-dark my-4" style="min-width: 200px">
                        Name: <div class="inline-block text-grey-darkest">{{ selectedId && selectedId.ClientName ? selectedId.ClientName : '' }}</div>
                    </div>
                    
                    <div class="text-grey-dark my-4 pl-2">
                        Current types: <div class="inline-block text-grey-darkest">{{ stdTypes }}</div>
                    </div>
                </div>

                <table class="table mb-0">
                    <thead>
                        <tr class="bg-grey-lighter">
                            <th scope="col">Type</th>
                            <th scope="col">Credential Label</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="detail in details">
                            <td>{{ detail.send_to_type }}</td>
                            <td>{{ detail.optional_credential_label }}</td>
                            <td>
                                <a :href="stdURL(detail.ID)"><i class="fa fa-eye fa-lg" aria-hidden="true"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</template>

<script>

import _ from 'lodash';

export default {
    props: ['searchUrl', 'sendToDetailsUrl'],
    data() {
        return {
            query: '',
            selectedId: null,
            ids: [],
            details: [],
            loading: false,
        }
    },
    watch: {
        query(newQuery) {
            axios.get(`${this.searchUrl}?q=${newQuery}`)
            .then(res => {
                this.ids = res.data.companies;
            })
        }
    },
    computed: {
        hasSelected() {
            return this.selectedId == null
        },
        stdCount() {
            if(this.selectedId == null && this.details.length < 1) {
                return '';
            }
            
            return this.details.length;
        },
        stdTypes() {
            if(this.selectedId == null && this.details.length < 1) {
                return '';
            }

            if(this.loading) {
                return '...';
            }

            if(this.details.length < 1) {
                return 'No Detail Types...'
            }

            const types = _.map(this.details, detail => detail.send_to_type);

            return _.toString(_.uniq(types));
        }
    },
    methods: {
        selected($event) {
            this.selectedId = $event;
            this.getSTD();
        },
        getSTD() {
            this.loading = true;
            axios.get(`${this.sendToDetailsUrl}?recruiting_id=${this.selectedId.recruiting_id}`, {
                'data': {},
            })
            .then(res => {
                this.loading = false;
                this.details = res.data.details.data
            })
        },
        clearSearch() {
            this.details = [];
            this.selectedId = null;
            this.$refs.search.handleInput('');
        },
        stdURL(id) {
            return `${this.sendToDetailsUrl}/${id}`;
        },
        newSTD() {
            window.location = `${this.sendToDetailsUrl}/create?recruiting_id=${this.selectedId.recruiting_id}`;
        }
    }

}

</script>

